import type { DocNode } from '@atlaskit/adf-schema';

import { cfetch } from '@confluence/network';

// Based on: https://developer.atlassian.com/cloud/confluence/rest/v2/api-group-page/#api-pages-post
export const createPage = (
	spaceId: string,
	contentId: string,
	adf: DocNode,
	isLivePage: boolean = false,
) => {
	return cfetch('/wiki/api/v2/pages', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			spaceId,
			parentId: contentId,
			status: 'draft',
			body: {
				representation: 'atlas_doc_format',
				value: JSON.stringify(adf),
			},
			...(isLivePage && {
				subtype: 'live',
			}),
		}),
	});
};
